// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconFilesFileFileError_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M26.75 32C29.6495 32 32 29.6495 32 26.75C32 23.8505 29.6495 21.5 26.75 21.5C23.8505 21.5 21.5 23.8505 21.5 26.75C21.5 29.6495 23.8505 32 26.75 32ZM24.875 23.75L23.75 24.875L25.625 26.75L23.75 28.625L24.875 29.75L26.75 27.875L28.625 29.75L29.75 28.625L27.875 26.75L29.75 24.875L28.625 23.75L26.75 25.625L24.875 23.75Z" fill="#ED5353"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M24.875 23.75L23.75 24.875L25.625 26.75L23.75 28.625L24.875 29.75L26.75 27.875L28.625 29.75L29.75 28.625L27.875 26.75L29.75 24.875L28.625 23.75L26.75 25.625L24.875 23.75Z" class="svg-fg"/>
  <path d="M5 0H17V2H7V28H19.6074C19.7302 28.7071 19.9556 29.3791 20.2675 30H5V0ZM27 19.5042V10H25V19.7126C25.3252 19.632 25.6591 19.5734 26 19.5383 26.0848 19.5296 26.1699 19.5224 26.2555 19.5166 26.3539 19.51 26.4529 19.5053 26.5523 19.5026 26.618 19.5009 26.6839 19.5 26.75 19.5 26.8337 19.5 26.917 19.5014 27 19.5042ZM19 0 27 8H19V0Z" class="svg-bg"/>
</svg>
`;
/**
 * IconFilesFileFileError is a generated icon component.
 */
let IconFilesFileFileError = IconFilesFileFileError_1 = class IconFilesFileFileError extends IconBaseElement {
    render() {
        return html `${IconFilesFileFileError_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconFilesFileFileError.icons = new Map([
    ['s8', _s32IconSvg],
    ['s12', _s32IconSvg],
    ['s16', _s32IconSvg],
    ['s24', _s32IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconFilesFileFileError = IconFilesFileFileError_1 = __decorate([
    customElement('zui-icon-files-file-file-error')
], IconFilesFileFileError);
export { IconFilesFileFileError };
